export const sourceLabels = { holiday: 'Holiday', override: 'Changed for this day', extra_shift: 'Extra shift', user_pattern: 'Personal pattern', template_swap: 'Swapped', allowance: 'Allowance' };
export function markers(day) { return [...new Set([...(day.sources || []), ...(day.shifts || []).flatMap(shift => shift.source || [])].map(source => sourceLabels[source.split(':')[0]]).filter(Boolean))]; }
export function overnight(shift, date) { return shift.end_at.slice(0, 10) > date; }
export function overrideRows(day, rows) {
  const ids = [...(day.sources || []), ...(day.shifts || []).flatMap(shift => shift.source || [])].filter(source => /^(override|extra_shift):/.test(source)).map(source => source.split(':')[1]);
  return rows.filter(row => ids.includes(String(row.id)));
}
export function canEditDay({ manager, lead, teamId, date, actorDays = [], day }) {
  if (teamId === null || teamId === undefined) return false;
  if (day?.sources?.includes('not_team_member')) return false;
  if (day?.team && String(day.team.id) !== String(teamId)) return false;
  // The target row's is_lead describes that person, not the logged-in actor.
  const ownTeam = actorDays.find(item => item.date === date)?.team;
  return manager || Boolean(lead && ownTeam?.is_lead === true && String(ownTeam.id) === String(teamId));
}
